import React from 'react';
import type { Locale } from '@jira/platform__supported-locales/src/supported-locales.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import type { CreatedComponent, User } from '../../../common/model/types.tsx';
import CreateModal from '../../../create-modal/index.tsx';
import { addComponentSuccess, addComponentFail } from '../../../state/actions.tsx';
import { getLocale } from '../../../state/context/selectors.tsx';
import {
	getProjectKey,
	getProjectId,
	getProjectDefaultAssignee,
	getProjectLead,
} from '../../../state/project/selectors.tsx';
import type { DefaultAssignee } from '../../../state/project/types.tsx';
import type { State as AppState } from '../../../state/reducer.tsx';
import { cancel } from '../../../state/ui/add/actions.tsx';
import { isOpen } from '../../../state/ui/add/selectors.tsx';

type ProjectKey = string;

type Props = {
	locale: Locale;
	projectKey: ProjectKey;
	projectId: number;
	projectDefaultAssignee: DefaultAssignee | undefined;
	projectLead: User | undefined;
	onClose: () => void;
	onComplete: (component: CreatedComponent) => void;
	onError: () => void;
	isDialogOpen: boolean;
};

function AddModal(props: Props) {
	const {
		locale,
		projectId,
		projectKey,
		projectDefaultAssignee,
		projectLead,
		onClose,
		onComplete,
		onError,
		isDialogOpen,
	} = props;

	if (!isDialogOpen) {
		return null;
	}

	return (
		<CreateModal
			locale={locale}
			projectId={projectId}
			projectKey={projectKey}
			projectDefaultAssignee={projectDefaultAssignee}
			projectLead={projectLead}
			onClose={onClose}
			onComplete={onComplete}
			onError={onError}
		/>
	);
}

type StateProps = Pick<
	Props,
	'locale' | 'isDialogOpen' | 'projectId' | 'projectKey' | 'projectDefaultAssignee' | 'projectLead'
>;

const mapStateToProps = (state: AppState): StateProps => ({
	locale: getLocale(state),
	isDialogOpen: isOpen(state),
	projectId: getProjectId(state),
	projectKey: getProjectKey(state),
	projectDefaultAssignee: getProjectDefaultAssignee(state),
	projectLead: getProjectLead(state),
});

type DispatchProps = Pick<Props, 'onClose' | 'onComplete' | 'onError'>;

const mapDispatchToProps: DispatchProps = {
	onClose: cancel,
	onComplete: addComponentSuccess,
	onError: addComponentFail,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddModal);
